import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import AGGridApproveCellRenderer from "@/components/inputs/AGGridApproveCellRenderer.vue";

export default class AGGridApproveColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = AGGridApproveCellRenderer;
    colDef.cellRendererParams = {
      metaData: this.column.metaData
    };
    return colDef;
  }
}
